import Vue from 'vue'
import VueRouter from 'vue-router'
import Menus from "@/pages/layout/Menus.vue";
import LoginPage from "@/pages/LoginPage.vue";
import RegistrationPage from "@/pages/RegistrationPage.vue";
import UserRegistrationPage from "@/pages/UserRegistrationPage.vue";
import TechSupportPage from "@/pages/TechSupportPage.vue";
import KlarnaRegistrationPage from "@/pages/KlarnaRegistrationPage.vue";
import FinishRegistrationPage from "@/pages/FinishRegistrationPage.vue";
import SplashScreen from "@/components/SplashScreen.vue";
import WelcomePage from "@/pages/WelcomePage.vue";
import DashboardPage from '@/pages/DashboardPage.vue';
import FilterBlockerPage from "@/pages/FilterBlockerPage.vue";
import DevicesManagerPage from "@/pages/DevicesManagerPage.vue";
import ProfilePage from "@/pages/ProfilePage.vue";
import AccountsPage from "@/pages/AccountsPage.vue";
import FirewallRulesPage from "@/pages/FirewallRulesPage.vue";
import NetworkPage from "@/pages/NetworkPage.vue";
import NetworkStatsPage from "@/pages/NetworkStatsPage.vue";
import PortForwardingPage from "@/pages/PortForwardingPage.vue";
import SettingsPage from "@/pages/SettingsPage.vue";
import SubscriptionsPage from "@/pages/user/SubscriptionsPage.vue";
import BillingSubscriptionPage from "@/pages/BillingSubscriptionPage.vue";
import DeviceRegistrationPage from "@/pages/DeviceRegistrationPage.vue";
import SiteManager from "@/pages/SiteManager.vue";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage.vue";
import ResetPasswordPage from "@/pages/ResetPasswordPage.vue";
import VPNConnectionPage from "@/pages/VPNConnectionPage.vue";
import SpeedTestPage from "@/pages/SpeedTestPage.vue";
import UpgradePromptPage from "@/pages/UpgradePromptPage.vue";
import { useLoginStore } from '@/stores/loginStore'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'splash',
    component: SplashScreen,
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: WelcomePage
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPasswordPage
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPasswordPage
  },
  {
    path: '/register',
    name: 'register',
    component: RegistrationPage
  },
  {
    path: '/registration',
    name: 'registration',
    component: RegistrationPage
  },
  {
    path: '/user-registration',
    name: 'user-register',
    component: UserRegistrationPage
  },
  {
    path: '/deviceregistration',
    name: 'deviceregistration',
    component: DeviceRegistrationPage
  },
  {
    path: '/klarna_register',
    name: 'klarna_register',
    component: KlarnaRegistrationPage
  },
  {
    path: '/auth/finishregistration',
    name: 'finishregistration',
    component: FinishRegistrationPage
  },
  {
    path: '/subscriptions',
    name: 'subscriptions',
    component: SubscriptionsPage
  },
  {
    path: '/menu',
    name: 'menu',
    component: Menus,
    redirect: '/menu/dashboard',
    children: [
      {
        path: '/menu/dashboard',
        name: 'dashboard',
        component: DashboardPage
      },
      {
        path: '/menu/filterBlocker',
        name: 'filterBlocker',
        component: FilterBlockerPage
      },
      {
        path: '/menu/devicesManager',
        name: 'devicesManager',
        component: DevicesManagerPage
      },
      {
        path: '/menu/profile',
        name: 'profile',
        component: ProfilePage
      },
      {
        path: '/menu/accounts',
        name: 'accounts',
        component: AccountsPage
      },
      {
        path: '/menu/firewallRules',
        name: 'firewallRules',
        component: FirewallRulesPage
      },
      {
        path: '/menu/network',
        name: 'network',
        component: NetworkPage
      },
      {
        path: '/menu/networkStats',
        name: 'networkStats',
        component: NetworkStatsPage
      },
      {
        path: '/menu/portForwarding',
        name: 'portForwarding',
        component: PortForwardingPage
      },
      {
        path: '/menu/settings',
        name: 'settings',
        component: SettingsPage
      },
      {
        path: '/menu/billingSubscription',
        name: 'billingSubscription',
        component: BillingSubscriptionPage
      },
      {
        path: '/menu/upgrade',
        name: 'upgrade',
        component: UpgradePromptPage
      },
      {
        path: '/menu/siteManager',
        name: 'siteManager',
        component: SiteManager
      },
      {
        path: '/menu/vpn',
        name: 'vpn',
        component: VPNConnectionPage
      },
      {
        path: '/menu/speedtest',
        name: 'speedtest',
        component: SpeedTestPage
      },
      {
        path: '/menu/techSupport',
        name: 'techSupport',
        component: TechSupportPage
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Route guard for subscription-based access control
router.beforeEach((to, from, next) => {
  const loginStore = useLoginStore()
  
  // Allow access to authentication routes
  const authRoutes = ['splash', 'welcome', 'login', 'register', 'registration', 'user-register', 
                     'forgot-password', 'reset-password', 'deviceregistration', 'klarna_register', 
                     'finishregistration', 'subscriptions']
  
  if (authRoutes.includes(to.name)) {
    next()
    return
  }
  
  // Check if user is logged in
  if (!loginStore.getLoggedIn) {
    next({ name: 'login' })
    return
  }
  
  // For logged-in users, let the components handle subscription restrictions
  // This prevents infinite redirect loops and allows for better UX with modals
  next()
})

export default router
